import { render, staticRenderFns } from "./status-form-modal.vue?vue&type=template&id=0f120180&scoped=true"
import script from "./status-form-modal.vue?vue&type=script&lang=js"
export * from "./status-form-modal.vue?vue&type=script&lang=js"
import style0 from "./status-form-modal.vue?vue&type=style&index=0&id=0f120180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f120180",
  null
  
)

export default component.exports